import axios from "axios";

export const dnsnetInstance = () =>
  axios.create({
    baseURL: process.env.REACT_APP_DNSNET_API_URL,
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-Auth-Token": "a31175ac-edc8-4873-a06a-9fe1e6f06970"
    },
  });

export const purtvInstance = () =>
  axios.create({
    baseURL: process.env.REACT_APP_PURTV_API_URL,
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      'X-Subscriber-Id': 'sXR73MqXYA-3GA_cfvvJ5g',
      'X-App-Id': '6504',
      'X-Api-Version': '1.0'
    },
  });
